import { ResizeDirections } from "@/scripts/common/enums.js";

export const DEFAULT_OPTIONS = {
    enabled: false,
    columns: 12,
    columnGap: 48,
    columnStart: 1,
    columnEnd: 7,
    height: null,
    autoHeight: false,
    minColumnSpan: 2,
    maxColumnSpan: 12,
    minHeight: null,
    maxHeight: null,
    mediaAspectRatio: null,
    onActivate: null,
    onResizeStart: null,
    onResize: null,
    onResizeEnd: null,
    onAspectRatioSnap: null,
    onMediaResize: null,
    resizeDirections: ResizeDirections.ALL,
    keepMediaSize: false,
    isMediaModule: false,
    fullBleedEnabled: false,
    onFullBleedChange: null,
    isFullBleed: false,
    enterFullBleedPx: 48,
    exitFullBleedPx: 24,
    useSpacers: true,
    isLocked: false,
};

export const POPULAR_ASPECT_RATIO_PRESETS = [
    { ratio: "21 : 9", value: [21, 9] },
    { ratio: "16 : 9", value: [16, 9] },
    { ratio: "4 : 3", value: [4, 3] },
    { ratio: "1 : 1", value: [1, 1] },
    { ratio: "3 : 4", value: [3, 4] },
    { ratio: "9 : 16", value: [9, 16] },
    { ratio: "9 : 21", value: [9, 21] },
    { ratio: "Original", value: null },
];

export function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
}

export function simplifyRatio(w, h) {
    if (!w || !h) return [w || 1, h || 1];
    const divisor = gcd(w, h);
    return [Math.round(w / divisor), Math.round(h / divisor)];
}

export function clamp(value, min, max) {
    if (min != null) value = Math.max(value, min);
    if (max != null) value = Math.min(value, max);
    return value;
}

export function cloneAspectRatioPresets() {
    return POPULAR_ASPECT_RATIO_PRESETS.map((preset) => ({
        ratio: preset.ratio,
        value: preset.value ? [...preset.value] : null,
    }));
}

export function mergeOptions(bindingValue = {}) {
    return {
        ...DEFAULT_OPTIONS,
        ...bindingValue,
    };
}
